import { Button } from '@/components/Button';
import { Modal } from '@/components/Modal';
import { Text } from '@/components/Text';
import { useCompanyStore } from '@/stores/useCompanyStore';
import i18n from '@/translations/config';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

export const UpdateCompanyGeneralDelete = () => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const { deleteCompany, loading } = useCompanyStore();

  const handleDeleteCompany = async () => {
    await deleteCompany(Number(id));
    navigate(`/${i18n.language}/dashboard/companies`);
  };

  const handleOpen = () => {
    setIsModalOpen(true);
  };

  const handleClose = () => {
    setIsModalOpen(false);
  };

  return (
    <div className="flex flex-col items-center justify-center md:items-start">
      <Text className="text-base font-medium text-sky-800">
        {t('updateCompany:general.delete.title')}
      </Text>
      <div className="mt-4">
        <Text className="mb-4 text-sm text-gray-600">
          {t('updateCompany:general.delete.description')}
        </Text>
        <Button className="w-full bg-danger lg:w-auto" onClick={handleOpen}>
          {t('updateCompany:general.delete.button')}
        </Button>
      </div>
      <Modal
        isOpen={isModalOpen}
        onClose={handleClose}
        className="w-auto"
        title={t('updateCompany:general.delete.confirm.title')}
      >
        <Text className="mb-4 text-gray-600">
          {t('updateCompany:general.delete.confirm.description')}
        </Text>
        <div className="mt-6 flex flex-row items-center justify-end gap-4">
          <Button onClick={handleClose}>{t('common:cancel')}</Button>
          <Button
            className="bg-danger"
            disabled={loading}
            onClick={handleDeleteCompany}
          >
            {t('common:confirm')}
          </Button>
        </div>
      </Modal>
    </div>
  );
};
